import React from 'react'
import { Container, Col, Row } from '@paypalcorp/pp-react'
import GithubIcon from '../../../../icons/githubIcon'
import data from '../../../../content/home/home.en-XC.yaml'

import './style.css'
import ProductOffering from './components/ProductOffering/index'

const Explore = () => {
  const { tiles } = data.content.explore || []

  return (
    <section className="explore">
      <Container>
        <Row>
          <Col className="floatCol">
            <h3 className="exploreHeader">Explore our APIs & SDKs</h3>
          </Col>
        </Row>
        <Row>
          <ProductOffering data={tiles} />
        </Row>
        <Row>
          <Col>
            <div className="alertBanner">
              <GithubIcon />
              <p className="alertBanner-txt">{data.content.explore.cta.text}</p>
              <a href={data.content.explore.cta.url} className="badgeLink">
                {data.content.explore.cta.linkText}
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Explore
